export default function SignupTypeSelect({ onSelect }: { onSelect: (type: string) => void }) {
  return (
    <div className="max-w-md mx-auto mt-20 p-8 shadow rounded bg-white">
      <h2 className="text-2xl font-bold mb-6 text-center">회원 유형 선택</h2>
      <div className="flex flex-col gap-5">
        <button className="border py-4 rounded text-lg hover:bg-gray-100" onClick={() => onSelect("fan")}>
          예술 애호가
        </button>
        <button className="border py-4 rounded text-lg hover:bg-gray-100" onClick={() => onSelect("worker")}>
          예술 종사자
        </button>
        <button className="border py-4 rounded text-lg hover:bg-gray-100" onClick={() => onSelect("artist")}>
          예술가
        </button>
      </div>
    </div>
  );
}
